module.exports = __webpack_public_path__ + "img/login-bg.fc5a2129.svg";